import type { ServicesApiInboxProviderMetrics } from '@/services/api/services-api';
import type { DeliverabilityMetricRow } from '../types';

function sum(values: number[]): number {
  return values.reduce((acc, val) => acc + val, 0);
}

export function transformMetricsToRows(
  inboxProviderMetrics: Record<string, ServicesApiInboxProviderMetrics>,
): DeliverabilityMetricRow[] {
  const totalSent = Object.values(inboxProviderMetrics).reduce((total, metrics) => {
    return total + sum(metrics.bounced) + sum(metrics.delivered);
  }, 0);

  return Object.entries(inboxProviderMetrics).map(([provider, metricsData]) => {
    const deliveryCount = sum(metricsData.delivered);
    const bounced = sum(metricsData.bounced);
    const openCount = sum(metricsData.opened);
    const humanOpenCount = sum(metricsData.human_opened);
    const clickCount = sum(metricsData.clicked);
    const humanClickCount = sum(metricsData.human_clicked);
    const spamCount = sum(metricsData.spammed);

    const sentCount = deliveryCount + bounced;

    return {
      provider,
      sentPercentage: totalSent > 0 ? sentCount / totalSent : 0,
      sentCount,
      deliveryRate: sentCount > 0 ? deliveryCount / sentCount : 0,
      deliveryCount,
      bounceRate: sentCount > 0 ? bounced / sentCount : 0,
      bounceCount: bounced,
      openRate: deliveryCount > 0 ? openCount / deliveryCount : 0,
      openCount,
      clickRate: deliveryCount > 0 ? clickCount / deliveryCount : 0,
      clickCount,
      spamRate: deliveryCount > 0 ? spamCount / deliveryCount : 0,
      spamCount,
      humanOpenRate: deliveryCount > 0 ? humanOpenCount / deliveryCount : 0,
      humanOpenCount,
      humanClickRate: deliveryCount > 0 ? humanClickCount / deliveryCount : 0,
      humanClickCount,
    };
  });
}

export function hasNoData(rows: DeliverabilityMetricRow[]): boolean {
  if (rows.length === 0) {
    return true;
  }

  if (rows.length === 1 && rows[0].sentPercentage === 0) {
    return true;
  }

  return false;
}
